import loadingLottie from '@/assets/lotties/loadingLottie.json';
import Lottie from 'lottie-react';

import { useModalLoadingStore } from '@/utils/store/store';

import { Dialog, DialogContent } from '../Dialog';

interface IModalLoadingProps {
  isLoading?: boolean;
  customLottie?: any;
}

const ModalLoading = ({ isLoading = false, customLottie }: IModalLoadingProps) => {
  const { loadingVisible, showLoading } = useModalLoadingStore();

  return (
    <Dialog open={loadingVisible || isLoading} onOpenChange={showLoading}>
      <DialogContent
        showClose={false}
        className="z-toast flex !max-h-fit !min-h-[0px] !min-w-[0px] !max-w-fit items-center justify-center outline-none"
        // overlay should overlay everything with very high priority

        // prevent closing by clicking outside or pressing Escape while loading
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <Lottie
          className="outline-none"
          animationData={customLottie || loadingLottie}
          loop
          style={{ width: 500, height: 300, padding: 0 }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ModalLoading;
